
<template>
  <v-main>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-container>
        <v-text-field
            clear-icon="mdi-close-circle"
            v-model="RepOrder_id"
            :rules="ocNumberRules"
            label="Pedido Id"
            required
            readonly
          ></v-text-field>
          <v-text-field
            clear-icon="mdi-close-circle"
            v-model="Proveedor"
            :rules="providerRules"
            label="Proveedor"
            readonly
            required
          ></v-text-field>
          <v-autocomplete v-model="RepOrderPenalityReason.RepOrderPenalityReason_id"
            :items="RepOrderPenalityReason"
            :item-text="'RepOrderPenalityReason_Desc'"
            :item-value="'RepOrderPenalityReason_id'"
            label="Motivo"
            outlined
            required
            :rules="[v => !!v || 'Este campo es requerido']"
          ></v-autocomplete>
          <v-text-field
            clearable
            clear-icon="mdi-close-circle"
            v-model="email"
            :rules="emailRules"
            label="Mail de Contacto"
            required
          ></v-text-field>
          <v-file-input 
          v-model="file" 
          label="Seleccione archivo para enviar."
          placeholder="Seleccione su archivo" 
          name="file"  
          id="file"
          ></v-file-input>
          <v-textarea
            v-model="incident"
            clearable
            clear-icon="mdi-close-circle"
            name="incident"
            label="Contenido Mail"
            :rules="incidentRules"
            hint="Detalle de la respuesta."
            required
          ></v-textarea>
          <v-card-actions class="justify-center">
            <v-btn
              class="mr-4"
              :disabled="!valid"
              color="primary"
              @click="sendMail()"
            >
              Enviar
            </v-btn>
          </v-card-actions>
      </v-container>
    </v-form>

    
    <v-dialog v-model="dialog_new" max-width="900px">
      <v-stepper v-model="e1" vertical>
          <p align-text="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
          <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">Envío de respuesta a la comunicación
              <small>Enviando mail.</small>
          </v-stepper-step>
          <v-stepper-content step="1">
          <v-card height="100px">
              <div class="text-center">
              <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
              {{this.msj_proceso}}
              </div>
          </v-card>
          </v-stepper-content>
      </v-stepper>
    </v-dialog>

  </v-main>
</template>


<script>
import axios from 'axios'
  export default {
    data: () => ({
      provider: '',
      RepOrderPenalityReason: {
        RepOrderPenalityReason_id: -1,
        RepOrderPenalityReason_Desc: 'No Informado.'
      },
      RepOrder_id: '',
      Proveedor: '',
      RepOrder2_id: '',
      Proveedor2: '',
      usuario:'',
      pedido_id:'',
      folio_id:'',
      punto:'',
      providerRules: [
      v => !!v || 'El proveedor es requerido.',
      ],
      reason: '',
      reasonRules: [
      v => !!v || 'El motivo es requerido.',
      ],
      email: '',
      emailRules: [
      v => !!v || 'El email es requerido.',
      v => /.+@.+/.test(v) || 'E-mail debe ser valido.',
      ],
      ocnumber: '',
      ocNumberRules: [
        v => !!v || 'El numero de OC es requerido.',
        v => (v && v.length <= 8) || 'El OC no puede tener más de 8 dígitos.',
        v => /^\d+$/.test(v)||'Este campo sólo acepta numeros.',
      ],
      pointRules: [
        v => !!v || 'El punto es requerido',
        v => (v && v.length <= 6) || 'El punto no puede tener más de 8 dígitos.',
        v => /^\d+$/.test(v)||'Este campo sólo acepta numeros.',
      ],
      point: '',
      incident: '',
      incidentRules: [
        v => !!v || 'La descripcion es requerida.',
      ],
      file: null,
      valid: false,
      config: {
          headers: {
              //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
              "api-user": 'admin'
          }
      },
      api_tool_url: process.env.VUE_APP_API_TOOL_URL,
      dialog: false,
      dialog_pass: false,
      dialog_new: false,
      progressBar: false,
      overlay: false,
      step_error1: true,
      step_error2: true,
      step_error3: true,
      step_color1: "primary",
      step_color2: "primary",
      step_color3: "primary",
      e1:0,
      msj_proceso:"",
    }),
    mounted() {
      this.RepOrder_id= atob(this.$route.params.id)
      this.Proveedor= decodeURIComponent(atob(this.$route.params.proveedor).replace(/\+/g, ' '));//
      this.RepOrder2_id= atob(this.$route.params.id)
      this.pedido_id = atob(this.$route.params.pedido_id)
      this.folio_id = atob(this.$route.params.folio_id)
      this.punto = atob(this.$route.params.punto)
      this.Proveedor2= decodeURIComponent(atob(this.$route.params.proveedor).replace(/\+/g, ' '));//
      this.usuario= decodeURIComponent(atob(this.$route.params.usuario).replace(/\+/g, ' '));//
    },
    
    watch: {
        dialog(val) {
            val || this.close()
        }
    },
    created () {
      this.initialize()
    },
    methods: {
      
      close() {
          this.dialog_new = false
      },

      initialize(){
        axios.post(this.api_tool_url + '/get_RepOrderPenalityReason', {}, this.config)
          .then(response => {
            this.RepOrderPenalityReason = response.data.ResultRows
          })
          .catch(error => {
            this.RepOrderPenalityReason = []
            alert(error.response.data.message)
          })
      },
      getRepOrderPenalityReason(statusId) {
        return this.RepOrderPenalityReason.find(s => s.RepOrderPenalityReason_id === statusId) || {}
      },

      sendMail() {
        this.dialog_new = true
          this.e1 = 1
          this.progressBar = true
          this.step_error1 = true
          this.step_error2 = true
          this.step_error3 = true
          this.step_color1 = "primary"
          this.step_color2 = "primary"
          this.step_color3 = "primary"
          this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
        
          let data = new FormData()
          const fileInput = document.getElementById('file');
          const file = fileInput.files[0];
          const RepOrderPenalityReason_Descr = this.getRepOrderPenalityReason(this.RepOrderPenalityReason.RepOrderPenalityReason_id).RepOrderPenalityReason_Desc
        

          if (file) {
            data.append('file', file);
            data.append('filename', file.name);
          }
          data.append('foo', 'bar');
          data.append('provider', this.Proveedor2)
          data.append('reason', RepOrderPenalityReason_Descr)
          data.append('ocnumber', this.RepOrder2_id)
          data.append('pedido_id', this.pedido_id)
          data.append('incident', this.incident)
          data.append('usuario', this.usuario)
          data.append('mail', this.email)
          data.append('folio_id', this.folio_id)
          data.append('punto', this.punto)
         
          axios.post(this.api_tool_url + '/SendAnswerPenality', data, this.config)
          .then(response => {
              if (response.status === 200) {
                  this.e1 = 1
                  this.step_color1 = "#008000"
                  this.progressBar = false
                  this.msj_proceso = 'Mail enviado.'
                  this.provider = ""
                  this.reason = ""
                  this.email = ""
                  this.file = null
                  this.incident = ""
                  this.ocnumber = ""
                  setTimeout(() => {
                    this.$router.push('/');
                  }, 10000);
              }
              else {
                  this.e1 = 1
                  this.step_color1 = "#C0392B"
                  this.progressBar = false
                  this.msj_proceso = response.statusText
                  this.btn = false
                  this.active = true
              }
              return response.data
          })
          .catch(error => {
              this.btn = false
              this.step_error1 = false
              this.progressBar = false
              this.msj_proceso = error.response.statusText
              this.active = true
          })
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/RepOrderPenalityAnswer.vue